import React, { useState } from "react";
import { Btn, Tip } from "./CityPhone";
import { INVEST_PRODUCTS } from "./cityCredit";
import { sfx } from "./citySfx";

export const VIP_NAMES = ["irving", "marke", "xzavier", "anthony", "teddy", "james"];
export const SAFE_MAX = 1000;

export function Bouncer({ vip, onPass, onClose }) {
  const [who, setWho] = useState(""); const [wrong, setWrong] = useState(0); const [pad, setPad] = useState(false); const [pw, setPw] = useState(""); const [bad, setBad] = useState(false);
  const say = (n) => { const k = n.trim().toLowerCase(); if (VIP_NAMES.includes(k)) { sfx.door(); onPass(k.charAt(0).toUpperCase() + k.slice(1)); } else { sfx.hit(); setWrong((w) => w + 1); setWho(""); } };
  const code = () => { if (pw.trim().toLowerCase() === "password") { sfx.door(); onPass(); } else { sfx.hit(); setBad(true); setPw(""); } };
  if (vip) return (
    <div className="space-y-3" data-testid="bouncer-vip">
      <p className="cq-px text-[9px] text-amber-200 leading-relaxed">"{vip.name}'s people. Go 'head."</p>
      <p className="font-mono text-[12px] text-slate-300">Big Teddy steps aside before you even open your mouth. You're on the list for good now.</p>
      <div className="flex gap-2"><Btn tone="amber" onClick={onPass} testid="bouncer-enter">GO IN THE BACK</Btn><Btn tone="ghost" onClick={onClose} testid="bouncer-later">NOT RIGHT NOW</Btn></div>
    </div>
  );
  return (
    <div className="space-y-3" data-testid="bouncer">
      <p className="cq-px text-[9px] text-white leading-relaxed">"WHO DO YOU KNOW?"</p>
      <p className="font-mono text-[12px] text-slate-300">Big Teddy is planted square in front of the only door back there. Arms folded, shades on, one eyebrow up. Say a name and say it like you mean it.</p>
      <div className="flex gap-2">
        <input value={who} onChange={(e) => setWho(e.target.value)} onKeyDown={(e) => e.key === "Enter" && say(who)} placeholder="say a name…" className="flex-1 bg-black/60 border border-slate-700 px-3 py-2 font-mono text-[13px] text-white outline-none focus:border-amber-400" data-testid="bouncer-input" autoFocus />
        <Btn tone="amber" onClick={() => say(who)} testid="bouncer-say">SAY IT</Btn>
      </div>
      {wrong > 0 && <p className="cq-px text-[7px] text-rose-300" data-testid="bouncer-wrong">"Never heard of 'em." {wrong > 1 ? "He's getting bored." : ""}</p>}
      {!pad ? (
        <Btn tone="ghost" onClick={() => { sfx.click(); setPad(true); }} testid="bouncer-keypad">"I GOT THE CODE"</Btn>
      ) : (
        <div className="space-y-2 border-t border-slate-800 pt-3" data-testid="bouncer-pad">
          <p className="font-mono text-[12px] text-slate-300">He grunts, reaches behind his back and flips open a green keypad. One shot.</p>
          <div className="flex gap-2">
            <input value={pw} type="password" onChange={(e) => setPw(e.target.value)} onKeyDown={(e) => e.key === "Enter" && code()} placeholder="code…" className="flex-1 bg-black/60 border border-slate-700 px-3 py-2 font-mono text-[13px] text-white outline-none focus:border-emerald-400" data-testid="bouncer-pad-input" autoFocus />
            <Btn tone="amber" onClick={code} testid="bouncer-pad-go">UNLOCK</Btn>
          </div>
          {bad && <p className="cq-px text-[7px] text-rose-300" data-testid="bouncer-pad-bad">WRONG CODE · the light goes red and Frank smirks</p>}
        </div>
      )}
      <Tip>Somebody in this city vouches for you. Ask around the Square — Anthony talks to everybody.</Tip>
    </div>
  );
}

export function VipDoor({ onOpen, onClose }) {
  const [pw, setPw] = useState(""); const [bad, setBad] = useState(false);
  const go = () => { if (pw.trim().toLowerCase() === "password") { sfx.door(); onOpen(); } else { sfx.hit(); setBad(true); setPw(""); } };
  return (
    <div className="space-y-3" data-testid="vipdoor">
      <p className="cq-px text-[9px] text-emerald-300">KEYPAD · ENTER CODE</p>
      <p className="font-mono text-[12px] text-slate-300">No sign, no handle. A green keypad and a little red light waiting on you.</p>
      <div className="flex gap-2">
        <input value={pw} type="password" onChange={(e) => setPw(e.target.value)} onKeyDown={(e) => e.key === "Enter" && go()} placeholder="code…" className="flex-1 bg-black/60 border border-slate-700 px-3 py-2 font-mono text-[13px] text-white outline-none focus:border-emerald-400" data-testid="vipdoor-input" autoFocus />
        <Btn tone="amber" onClick={go} testid="vipdoor-go">UNLOCK</Btn>
      </div>
      {bad && <p className="cq-px text-[7px] text-rose-300" data-testid="vipdoor-bad">WRONG CODE · the light goes red</p>}
      <Btn tone="ghost" onClick={onClose} testid="vipdoor-close">BACK OFF THE DOOR</Btn>
      <Tip>Or skip the code entirely — get on Big Teddy's list once and he waves you straight through from then on.</Tip>
    </div>
  );
}

export function VaultSafe({ credit, onWithdraw }) {
  const [sel, setSel] = useState(null); const [amt, setAmt] = useState("");
  const accts = (credit?.invest || []).filter((a) => a.balance > 0.5);
  const a = accts.find((x) => x.id === sel) || accts[0];
  const cap = a ? Math.min(SAFE_MAX, Math.floor(a.balance)) : 0;
  const n = Math.min(cap, Math.max(0, Math.floor(Number(amt) || 0)));
  return (
    <div className="space-y-3" data-testid="vault-safe">
      <p className="cq-px text-[8px] text-amber-200">THE HOUSE SAFE · UP TO {SAFE_MAX} COINS A PULL</p>
      {!accts.length ? <p className="font-mono text-[12px] text-slate-300" data-testid="safe-empty">Nothing of yours in here yet. Stash coins in a bank account upstairs first — then come pull it out down here, any hour, no teller.</p> : (
        <>
          <div className="flex gap-2 flex-wrap">
            {accts.map((x) => { const P = INVEST_PRODUCTS.find((p) => p.id === x.id); const on = a?.id === x.id; return (
              <button key={x.id} onClick={() => { setSel(x.id); setAmt(""); sfx.click(); }} className={`cq-px text-[7px] px-3 py-2 border ${on ? "border-amber-400 text-amber-200 bg-amber-400/10" : "border-slate-700 text-slate-400"}`} data-testid={`safe-acct-${x.id}`}>{(P?.name || x.id).toUpperCase()} · {Math.floor(x.balance)}</button>); })}
          </div>
          <div className="flex gap-2 items-center">
            <input value={amt} onChange={(e) => setAmt(e.target.value.replace(/\D/g, ""))} placeholder={`amount (max ${cap})`} className="flex-1 bg-black/60 border border-slate-700 px-3 py-2 font-mono text-[13px] text-white outline-none focus:border-amber-400" data-testid="safe-amount" />
            <Btn tone="ghost" onClick={() => setAmt(String(cap))} testid="safe-max">MAX</Btn>
          </div>
          <Btn tone="amber" onClick={() => { if (n > 0) { onWithdraw(a.id, n); setAmt(""); } }} testid="safe-pull">PULL {n || 0} COINS OUT THE SAFE</Btn>
          <p className="cq-px text-[7px] text-slate-400" data-testid="safe-note">Stacks are banded in 100s. Anything over {SAFE_MAX} at once and the alarm asks questions.</p>
        </>
      )}
      <Tip>Real money moves quietly. This is still your bank balance — the safe is just a faster door to it.</Tip>
    </div>
  );
}

export function Butler({ coins, onCoins, onToast, onGlass, onBottle }) {
  const [bottles, setBottles] = useState(() => Number(localStorage.getItem("cq_bottles") || 0));
  const buy = () => {
    if (coins < 250) { onToast('ALFRED: "Perhaps when the safe is a little fuller, sir."'); return; }
    onCoins(-250); const n = bottles + 1; setBottles(n); localStorage.setItem("cq_bottles", String(n));
    sfx.win(); onBottle?.();
    onToast('BOTTLE SERVICE · sparklers, a bucket and the whole room turns to look. That is bottle number ' + n + ' tonight.');
  };
  return (
    <div className="space-y-3" data-testid="butler">
      <p className="cq-px text-[9px] text-amber-200 leading-relaxed">"Good evening. Whatever you need."</p>
      <p className="font-mono text-[12px] text-slate-300">Alfred stands perfectly still with a silver tray: champagne on the left, banded stacks on the right, and absolutely no questions. You have {coins} coins on you.</p>
      <div className="flex gap-2 flex-wrap">
        <Btn tone="amber" onClick={() => { onCoins(1000); sfx.coin(); onToast('ALFRED: "The house takes care of its own, sir." · +1,000 coins'); }} testid="butler-tip">TAKE A STACK · +1,000 COINS</Btn>
        <Btn tone="ghost" onClick={() => { sfx.click(); onGlass?.(true); onToast('ALFRED: "Chilled to exactly four degrees, sir." · you carry the glass with you now'); }} testid="butler-drink">A GLASS OF CHAMPAGNE</Btn>
        <Btn tone="ghost" onClick={() => { sfx.click(); onGlass?.(false); onToast("You set the empty glass back on Alfred's tray."); }} testid="butler-putdown">PUT THE GLASS DOWN</Btn>
        <Btn tone="amber" onClick={buy} testid="butler-bottle">BOTTLE SERVICE · 250 COINS</Btn>
      </div>
      <p className="cq-px text-[7px] text-slate-400" data-testid="butler-bottles">BOTTLES ORDERED TONIGHT: {bottles}</p>
      <Tip>Take as many stacks as you want — down here the tray never runs out. Upstairs still costs what it costs.</Tip>
    </div>
  );
}
